export default __webpack_public_path__ + "static/media/rollingStock.13380194.svg";